import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getMobileAppInstallationCount = (fromDate, toDate, userGroupId) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ADOPTION_REPORT.GET_MOBILE_APP_INSTALLATION_COUNT(
      fromDate,
      toDate,
      userGroupId
    ),
    cancelToken
  );
};

export default getMobileAppInstallationCount;
